import { computed } from 'vue'

export const useAnnouncementSchedule = () => {
	const startDate = import.meta.env.VITE_ANNOUNCEMENT_START_DATE
	const endDate = import.meta.env.VITE_ANNOUNCEMENT_END_DATE

	if (!startDate || !endDate) {
		return {
			showAnnouncement: computed(() => false),
			hasAnnouncementEnded: computed(() => false),
		}
	}

	const announcementStartDate = new Date(startDate)
	const announcementEndDate = new Date(endDate)

	const showAnnouncement = computed(() => {
		const now = new Date()
		return now >= announcementStartDate && now <= announcementEndDate
	})

	const hasAnnouncementEnded = computed(() => {
		const now = new Date()
		return now >= announcementEndDate
	})

	return { showAnnouncement, hasAnnouncementEnded }
}
